import {type FC} from "react"
import {Box} from "@mui/material"
import ExpertText from "../../atoms/expertText/ExpertText"
import ViewBio from "../../atoms/viewBio/ViewBio"
import ImageAvatar from "../../atoms/imageAvatar/ImageAvatar"
import EmailButton from "../../atoms/emailButton/EmailButton"
import {Account, AccountTeam} from "../../../types"
import EllipsisTypography from "../../atoms/customTypography/EllipsisTypography"
import {TruncatedTooltip} from "../../atoms/Tooltip"

type Props = {
  authorId: string
  authorName: string
  imagePath: string
  location: string[] | null
  tags: string[] | null
  parentRef?: any
  selectedMember: AccountTeam
  contactData: Account
  contactTeamData: AccountTeam[]
}

const expertDetailCard: FC<Props> = (props) => {
  const {
    authorId,
    authorName,
    imagePath,
    location,
    tags,
    selectedMember,
    contactData,
    contactTeamData,
  } = props
  const locationValue = location && location.length > 0 ? location[0] : ""

  return (
    <Box
      flexDirection={"row"}
      display={"flex"}
      width={"100%"}
      marginBottom={"16px"}
    >
      <Box
        flexDirection={"column"}
        display={"flex"}
        width={"17%"}
        justifyContent={"center"}
        alignItems={"end"}
        paddingRight={"8px"}
      >
        <ImageAvatar size="56px" src={imagePath} />
      </Box>
      <Box flexDirection={"column"} display={"flex"} width={"60%"}>
        <Box
          flexDirection={"row"}
          display={"flex"}
          width={"100%"}
          height={"20px"}
        >
          <Box flexDirection={"column"} display={"flex"} width={"100%"}>
            <EllipsisTypography
              text={authorName}
              lines={1}
              fontSize={14}
              lineHeight="20px"
              tooltipComponent={TruncatedTooltip}
              color="#1c1c1c"
            />
          </Box>
          <Box flexDirection={"column"} display={"flex"} width={"15%"}>
            <EmailButton
              height={"24px"}
              width={"24px"}
              fill={"#053747"}
              selectedMember={selectedMember}
              contactData={contactData}
              contactTeamData={contactTeamData}
            />
          </Box>
        </Box>
        <Box flexDirection={"row"} display={"flex"} height={"16px"}>
          <ExpertText
            label={locationValue}
            tags={[locationValue]}
            style={{
              fontSize: "12px",
              color: "#1c1c1c66",
              fontFamily: "Open Sans",
            }}
          />
        </Box>
        <Box flexDirection={"row"} display={"flex"} height={"16px"}>
          {tags && (
            <ExpertText
              tags={tags}
              parentRef={props.parentRef}
              style={{
                fontSize: "12px",
                color: "#1c1c1c66",
                fontFamily: "Open Sans",
              }}
            />
          )}
        </Box>
      </Box>
      <Box
        flexDirection={"column"}
        display={"flex"}
        justifyContent={"start"}
        width={"23%"}
        alignItems={"end"}
      >
        <ViewBio
          expertId={authorId}
          style={{
            display: "flex",
            color: "#053747",
            fontSize: "14px",
            fontWeight: 600,
          }}
        />
      </Box>
    </Box>
  )
}

export default expertDetailCard
